export default __webpack_public_path__ + "static/media/small-size-quadrants-first.21b34203.png";